<script>
	import "../shared.css";

	export let deck;
	export let title;
	export let preview = false; // Showing the side that isn't currently in effect
	export let onFlip = null;
</script>

<div class="bot bot-flex">
	<div class="bot-header">
		<span class="bot-name font-heading">{deck.toUpperCase()}</span>
		<span class="font-block bot-title">{title.toUpperCase()}</span>
		{#if preview}<span class="preview font-heading">PREVIEW</span>{/if}
		{#if onFlip}
			<button class="flip" title="Flip card" on:click|stopPropagation={onFlip}>
				<svg viewBox="0 0 24 24"><path d="M4 9a8 8 0 0 1 14-3l2-2v6h-6l2.3-2.3A5.5 5.5 0 0 0 6.6 9.5zM20 15a8 8 0 0 1-14 3l-2 2v-6h6l-2.3 2.3a5.5 5.5 0 0 0 9.7-1.8z" /></svg>
			</button>
		{/if}
	</div>
	<slot />
</div>

<style lang="scss">
	// Adam's layout is for a 350x600px card: --u is 1px at that size, --height feeds OperationText/chips
	.bot {
		--u: calc(var(--bot-h) / 600);
		--height: calc(var(--u) * 401);
		--width: calc(var(--u) * 287);
		display: flex;
		flex-direction: column;
		height: var(--bot-h);
		width: calc(var(--u) * 350);
		font-size: calc(var(--u) * 16);
		box-sizing: border-box;
		border-radius: calc(var(--u) * 8);
		border: 1px solid black;
		background-color: #0b2547;
		overflow: hidden;
		flex-shrink: 0;
		color: black;
		text-align: left;
	}
	// Unscoped so it stays weaker than the chips' own inline-flex
	:global(.bot-flex div) {
		display: flex;
	}
	.bot-header {
		color: white;
		padding: calc(var(--u) * 5) 1em;
		gap: 0.5em;
		align-items: baseline;
	}
	.bot-name {
		font-weight: 900;
	}
	.bot-title {
		font-size: calc(var(--u) * 13);
		font-weight: 400;
	}
	.preview {
		color: gold;
		font-size: calc(var(--u) * 13);
	}
	.flip {
		margin-left: auto;
		align-self: center;
		background: none;
		border: none;
		padding: 0;
		cursor: pointer;
		width: calc(var(--u) * 22);
		height: calc(var(--u) * 22);
		& > svg {
			width: 100%;
			height: 100%;
			fill: white;
		}
		&:hover > svg {
			fill: gold;
		}
	}
</style>
